'use client'

import { useContext } from 'react'
import { Navigate } from 'react-router-dom'

import { ShowAtBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'
import { UiState } from '@marketplace-web/shared/ui-state-util'
import {
  CONVERSATION_URL,
  messagingClickEvent,
} from '@marketplace-web/messaging/conversation-messaging-data'
import { ConversationListContext } from '@marketplace-web/messaging/conversation-providers-feature'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'

import ConversationListEmptyState from '../ConversationListEmptyState'
import { isBrazeConversation } from '../../utils/conversation'

const RedirectToFirstConversation = () => {
  const { track } = useTracking()
  const { conversations, uiState } = useContext(ConversationListContext)

  if (!conversations.length) {
    if (uiState === UiState.Success)
      return (
        <ShowAtBreakpoint breakpoint="desktops">
          <ConversationListEmptyState />
        </ShowAtBreakpoint>
      )

    return null
  }

  if (!isBrazeConversation(conversations[0]!))
    track(
      messagingClickEvent({
        target: 'open_conversation',
        conversationId: conversations[0]!.id,
        info: conversations[0]!.unread ? 'unseen' : 'seen',
        screen: 'inbox',
      }),
    )

  return <Navigate to={CONVERSATION_URL(conversations[0]!.id)} replace />
}

export default RedirectToFirstConversation
